module.exports = "<div class=station-timeseries-container layout=column flex> <md-card flex> <md-tabs class=full-height-tabs flex md-selected=$ctrl.selectedTabIndex> <md-tab> <md-tab-label> <span translate>PRECIPITATION</span> </md-tab-label> <md-tab-body> <imomo-meteostation-timeseries-graph hydrodata-type=\"'precipitation'\"></imomo-meteostation-timeseries-graph> </md-tab-body> </md-tab> <md-tab> <md-tab-label> <span translate>TEMPERATURE</span> </md-tab-label> <md-tab-body> <imomo-meteostation-timeseries-graph hydrodata-type=\"'temperature'\"></imomo-meteostation-timeseries-graph> </md-tab-body> </md-tab> </md-tabs> </md-card> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./app/meteostation/timeseries/timeseries.html
 ** module id = 550
 ** module chunks = 0
 **/